module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    staticClass: "coupon-modal",
    attrs: {
      "value": _vm.show,
      "mask-closable": false,
      "footer-hide": true,
      "header-hide": true
    },
    on: {
      "on-visible-change": _vm.handleVisbleChange
    }
  }, [_c('div', {
    staticClass: "coupon-inner"
  }, [_c('img', {
    attrs: {
      "src": require("../images/coupon-modal-bg.png"),
      "alt": "优惠券"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "coupon-content"
  }, [_c('h3', [_vm._v("优惠券")]), _vm._v(" "), _c('div', {
    staticClass: "coupon-price"
  }, [_c('span', {
    staticClass: "price-unit"
  }, [_vm._v("￥")]), _vm._v(" "), _c('span', {
    staticClass: "price-value"
  }, [_vm._v(_vm._s(_vm._f("numeral")(_vm.coupon.totalMoney)))])]), _vm._v(" "), _c('button', {
    staticClass: "makeOrder-btn",
    on: {
      "click": _vm.handleGo
    }
  }, [_vm._v("立即下单")]), _vm._v(" "), _c('div', {
    staticClass: "coupon-desc"
  }, [_c('div', {
    staticClass: "coupo-desc__left"
  }, [_c('p', [_vm._v("单张面额：" + _vm._s(_vm.coupon.value) + "元")]), _vm._v(" "), _c('p', [_vm._v("此次发放：" + _vm._s(_vm.coupon.totalNum) + "张")]), _vm._v(" "), _c('p', [_vm._v("有效期：" + _vm._s(_vm._f("dateFmt")(_vm.coupon.beginTime)) + "-" + _vm._s(_vm._f("dateFmt")(_vm.coupon.endTime)))])]), _vm._v(" "), _c('div', {
    staticClass: "coupo-desc__right"
  }, [_vm._v("最终解释权归鸭嘴兽所有")])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-58f7cf13", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58f7cf13"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":false}!./src/components/coupon-modal.vue
// module id = 1361
// module chunks = 61